import type { WeeklyIssue } from '../types/daily'
import type { ShareDiscussionResult } from './discussion'

export const buildWeeklyDiscussionText = (issue: WeeklyIssue) => [
  '我想完成下面这份 Daily Read 周末英语写作练习：',
  '',
  `周刊：${issue.editorial.title}`,
  `时间：${issue.weekStart} 至 ${issue.weekEnd}`,
  `本周主题：${issue.themes.map((theme) => theme.title).join('；')}`,
  '',
  `写作题目：${issue.outputExercise.promptEn}`,
  `字数：${issue.outputExercise.targetWords.min}–${issue.outputExercise.targetWords.max} words`,
  `写作提示：${issue.outputExercise.guidanceZh}`,
  '',
  '可用背景：',
  ...issue.outputExercise.contextBullets.map((bullet) => `- ${bullet}`),
  '',
  '请先让我独立作答；然后从论点、证据、结构和英文表达四方面给反馈，不要直接代写。',
].join('\n')

export async function shareWeeklyExercise(issue: WeeklyIssue): Promise<ShareDiscussionResult> {
  const value = buildWeeklyDiscussionText(issue)
  if (navigator.share) {
    try {
      await navigator.share({ title: `Daily Read 周刊：${issue.editorial.title}`, text: value })
      return { status: 'shared' }
    } catch (error) {
      if (typeof error === 'object' && error !== null && 'name' in error && error.name === 'AbortError') return { status: 'cancelled' }
    }
  }
  try {
    if (!navigator.clipboard) throw new Error('Clipboard API unavailable')
    await navigator.clipboard.writeText(value)
    return { status: 'copied' }
  } catch {
    return { status: 'manual', value }
  }
}
